export class BadgeModel {
    name = '';
    icon?: string;
    color?: string;
    onClick?: Function;
}
